import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => setTime(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);

    return (
        <footer className="footer">
            <div className="footer-column left">
                <p>&copy; {new Date().getFullYear()} Pierre Bars</p>
                <Link to="/legal">Legal Mentions</Link>
                <Link to="/privacy">Privacy Policy</Link>
            </div>

            <div className="footer-column center">
                <p>{time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</p>
                <p className="resolution-text">
                    {window.screen.width}x{window.screen.height}
                </p>
            </div>

            <div className="footer-column center-right">
                <h4>Follow Us</h4>
                <a href="https://www.instagram.com/pierre.bars/" target="_blank" rel="noopener noreferrer">Instagram</a>
                <a href="https://www.youtube.com/@pierrebars" target="_blank" rel="noopener noreferrer">Youtube</a>
            </div>

            <div className="footer-column right">
                <Link to="/">Home</Link>
                <Link to="/projects">Projects</Link>
                <Link to="/contact">Contact</Link>
            </div>
        </footer>
    );
};

export default Footer;
